import { CoreUiException } from "./core-ui-exception";

/**
 * Occurs when an item is not found
 */
export class NotFoundException extends CoreUiException {

    constructor(message: string, originalError?: any) {

        super("NotFoundException", message, originalError);

        // Work around for Error Extension
        // https://github.com/Microsoft/TypeScript/wiki/Breaking-Changes#extending-built-ins-like-error-array-and-map-may-no-longer-work
        Object.setPrototypeOf(this, NotFoundException.prototype);
    }
}
